import React, { SVGProps } from 'react'
const SvgFilterFunnel = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox={'0 0 16 16'}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M1.33337 3.06667C1.33337 2.6933 1.33337 2.50661 1.40604 2.36401C1.46995 2.23856 1.57194 2.13658 1.69738 2.07266C1.83999 2 2.02667 2 2.40004 2H13.6C13.9734 2 14.1601 2 14.3027 2.07266C14.4281 2.13658 14.5301 2.23856 14.594 2.36401C14.6667 2.50661 14.6667 2.6933 14.6667 3.06667V3.51293C14.6667 3.69213 14.6667 3.78173 14.6448 3.86504C14.6254 3.93887 14.5935 4.00882 14.5504 4.07184C14.5018 4.14295 14.4341 4.20164 14.2986 4.319L10.0348 8.01434C9.89936 8.1317 9.83166 8.19038 9.78304 8.26149C9.73995 8.32451 9.70801 8.39446 9.68861 8.46829C9.66671 8.55161 9.66671 8.64121 9.66671 8.8204V12.3056C9.66671 12.436 9.66671 12.5011 9.64568 12.5575C9.6271 12.6073 9.59688 12.6519 9.55754 12.6877C9.51302 12.7281 9.4525 12.7524 9.33145 12.8008L7.06478 13.7074C6.81975 13.8054 6.69724 13.8545 6.59889 13.834C6.51288 13.8161 6.43741 13.765 6.38888 13.6918C6.33337 13.6081 6.33337 13.4762 6.33337 13.2122V8.8204C6.33337 8.64121 6.33337 8.55161 6.31148 8.46829C6.29207 8.39446 6.26013 8.32451 6.21705 8.26149C6.16843 8.19038 6.10072 8.1317 5.9653 8.01434L1.70145 4.319C1.56603 4.20164 1.49832 4.14295 1.4497 4.07184C1.40662 4.00882 1.37468 3.93887 1.35527 3.86504C1.33337 3.78173 1.33337 3.69213 1.33337 3.51293V3.06667Z"
      stroke={props.stroke || 'var(--color-cta)'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgFilterFunnel
